(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const carousel = document.querySelector('.carousel');
    if (carousel) {
      new Flickity(carousel, {
        cellAlign: 'left',
        contain: true,
        autoPlay: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
